module.exports = __webpack_public_path__ + "static/img/hr-servie.12ce6abd.png";